import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { Router } from '@angular/router';

@Injectable()
export class ConnectionService{
    constructor(private http: HttpClient, private router: Router){}

    Get_URL():string{
        var currenturl : string = "";
        var returnurl : string = "";

        currenturl =window.location.href
        if (currenturl.includes("http://192.168.4.221")){
            returnurl = "http://192.168.4.221:442"
        } 
        
        if (currenturl.includes("http://localhost")){
            //returnurl = "http://192.168.4.221:442"
            returnurl = "http://localhost:3000"

        } 
        if (currenturl.includes("https://clxd.skyversa.com")){
            returnurl = "https://clxd.skyversa.com"
        } 


      
        return returnurl;

    }

   
}   